module.exports = __webpack_public_path__ + "assets/img/keji.622c036a.jpg";